import NoImage from 'assets/images/icons/project-no-photo.svg';
import i18n from 'i18next';
import { shareTypesIcons } from 'configs';

export const getProjectImgAndShareIcon = item => {
  const Icon = shareTypesIcons[item.visibility];
  const isNoImage = !item.icon;
  const image = isNoImage ? NoImage : item.icon;
  return { Icon, image, isNoImage };
};

export const getProductVal = (product, parseKey, mainKey) => {
  const parseVal = product.item && product.item[parseKey];
  return parseVal || (mainKey ? product[mainKey] : null);
};

export const getFavicon = url => {
  if (!url) return null;
  const domain = new URL(url).host;
  return `https://www.google.com/s2/favicons?sz=64&domain=${domain}`;
};

export const trimProductUrl = url => {
  if (!url) return null;
  const pathname = new URL(url).pathname;
  const texts = pathname.split('/').filter(v => v);
  return texts.length ? texts[0] : null;
};

export const getProductProperties = props => {
  if (!props) return [];
  let results = [];
  props.forEach(item => {
    results = [...results, ...JSON.parse(item)];
  });
  return results;
};

export const getProductPriceTrand = product => {
  if (!product.priceTrend) return null;
  return product.priceTrend === -1 ? 'down' : 'up';
};

export const collectProductInfo = product => {
  const productUrl = product.url || 'https://likiee.com';
  const images = product.images || getProductVal(product, 'images');
  return {
    images: images,
    isSlide: images && images.length > 1,
    mainImage: product.imageURL || getProductVal(product, 'mainImage', 'imageUrl'),
    favIcon: product.source?.faviconURL || getFavicon(productUrl),
    sourceName: product.source?.name || new URL(productUrl)?.host,
    name: product.name || getProductVal(product, 'title', 'name') || i18n.t('text_extracting_details'),
    description: getProductVal(product, 'description', 'description'),
    properties: getProductProperties(product.additionalProperty || product.item?.additionalProperty),
    thumbnails: getProductVal(product, 'thumbnailURLs', 'thumbnailURLs'),
    priceTrand: getProductPriceTrand(product),
  };
};
